import React, { useEffect, useRef, useState } from 'react';
import { ChatFeed, ChatThreadContainer, FeedItem } from './styled';
import UserChat from './UserChat';
import BotChat from './BotChat';
import ChatSeparator from './ChatSeparator';
import { useAtom } from 'jotai';
import { chatFeedAtom } from '../atoms';
import ErrorInChat from './ErrorInChat';
import { metricsStore } from '@globalStore/metricsStore';
import { CURRENT_PRODUCT_MODE } from '@utils/constants';

function ChatThread({ getStream, isLoading }) {
  const [chatFeed] = useAtom(chatFeedAtom);
  const [allMetricsObj, setAllMetrics] = useState({});
  const [allMetricMeta, setAllMetricMeta] = useState({});
  const messagesEndRef = useRef<HTMLInputElement | null>(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    // relate to https://conviva.atlassian.net/browse/AAA-208
    setTimeout(() => {
      scrollToBottom();
    }, 10);
  }, [chatFeed]);

  useEffect(() => {
    let allMetrics = {};
    const { metricsMeta } = metricsStore.getState();
    /**
     * This is used for promptAI, the scenario is that user can query metrics across the products
     * like querying EI metrics in app prompt AI page
     * and the format logic in IF client needs to get the metric list in all products
     *
     * Some metrics may occur in both EI and APP, so we have to make sure of the order of merging these objects.
     */
    if (CURRENT_PRODUCT_MODE === 'EI') {
      allMetrics = {
        ...metricsMeta.ai,
        ...metricsMeta.app,
        ...metricsMeta.ei,
      };
    } else if (CURRENT_PRODUCT_MODE === 'APP') {
      allMetrics = {
        ...metricsMeta.ai,
        ...metricsMeta.ei,
        ...metricsMeta.app,
      };
    } else if (CURRENT_PRODUCT_MODE === 'AI') {
      allMetrics = {
        ...metricsMeta.app,
        ...metricsMeta.ei,
        ...metricsMeta.ai,
      };
    } else {
      allMetrics = {
        ...metricsMeta.app,
        ...metricsMeta.ai,
        ...metricsMeta.ei,
      };
    }
    setAllMetrics(allMetrics);
    setAllMetricMeta(metricsMeta);
  }, []);

  const content = chatFeed.map((chatBlock) => {
    const { userMsg, error, timestamp, botData, canceler } = chatBlock;

    // a new question-response set
    if (userMsg) {
      return (
        <>
          <FeedItem>
            <UserChat userMsg={userMsg} />
            {error ? (
              <ErrorInChat error={error} />
            ) : (
              <BotChat
                userMsg={userMsg}
                timestamp={timestamp}
                botData={botData}
                getStream={getStream}
                isLoading={isLoading}
                canceler={canceler}
                allMetricsObj={allMetricsObj}
                allMetricMeta={allMetricMeta}
              />
            )}
          </FeedItem>
          <ChatSeparator timestamp={timestamp} />
        </>
      );
    } else {
      return null;
    }
  });

  return (
    <ChatThreadContainer>
      <ChatFeed>
        {content}
        <div ref={messagesEndRef} />
      </ChatFeed>
    </ChatThreadContainer>
  );
}

export default ChatThread;
